import { CSSObject } from "styled-components";
import { vfxTheme } from "../Theme/theme";

interface ButtonStyles {
  root: CSSObject;
  contained: CSSObject;
  containedPrimary: CSSObject;
  containedSecondary: CSSObject;
  outlinedPrimary: CSSObject;
  sizeSmall: CSSObject;
}

const useButtonStyles = (): ButtonStyles => {
  
  return {
    root: {
      borderRadius: vfxTheme.spaceUnits.sp01,
      fontFamily: vfxTheme.fontFamily,
      fontSize: vfxTheme.spaceUnits.sp02 + 4,
      fontWeight: vfxTheme.fontWeights.regular,
      lineHeight: `${vfxTheme.spaceUnits.sp01 * 4 + 2}px`,
      color: vfxTheme.palette.white,
      textTransform: "none",
      backgroundColor: vfxTheme.palette.blueGreys.bg400,
    },
    contained: {
      backgroundColor: vfxTheme.palette.blueGreys.bg100,
      boxShadow: "none",
      "&:hover": {
        backgroundColor: vfxTheme.palette.blueGreys.bg200,
        boxShadow: vfxTheme.shadowTypes.buttonHover,
      },
      "&:disabled": {
        backgroundColor: vfxTheme.palette.blueGreys.bg50,
        color: vfxTheme.palette.blueGreys.bg300,
      },
    },
    containedPrimary: {
      backgroundColor: vfxTheme.palette.primary.main,
      "&:hover": {
        backgroundColor: vfxTheme.palette.primary.dark,
      },
      "&:disabled": {
        backgroundColor: vfxTheme.palette.blueGreys.bg50,
        color: vfxTheme.palette.blueGreys.bg300,
      },
    },
    containedSecondary: {
      backgroundColor: vfxTheme.palette.secondary.main,
      "&:hover": {
        backgroundColor: vfxTheme.palette.secondary.dark,
      },
      "&:disabled": {
        backgroundColor: vfxTheme.palette.blueGreys.bg50,
        color: vfxTheme.palette.blueGreys.bg300,
      },
    },
    outlinedPrimary: {
      "&:hover": {
        backgroundColor: vfxTheme.palette.primary.light,
        boxShadow: vfxTheme.shadowTypes.buttonHover,
      },
      "&:focus": {
        backgroundColor: vfxTheme.palette.primary.light,
        boxShadow: vfxTheme.shadowTypes.buttonHover,
      },
    },
    sizeSmall: {
      fontWeight: vfxTheme.fontWeights.regular,
      paddingTop: 2,
      paddingRight: vfxTheme.spaceUnits.sp01,
      paddingBottom: 2,
      paddingLeft: vfxTheme.spaceUnits.sp01,
    },
  };
};

export default useButtonStyles;
